import React from "react";
import { Box, Typography, styled } from "@mui/material";
import classNames from "classnames";

function TrackCard({ item, className }) {
  function getDisplayStatus(stage, status) {
    if (stage === "Project") {
      if (
        [
          "Receive Contract",
          "Process Deposit",
          "Contract Review",
          "Mark Out",
          "Expeditor Review",
          "Schedule Installation",
          "Process Balance",
        ].includes(status)
      ) {
        return "Sold";
      } else if (
        ["Final Review", "Labor Bill & Commission", "Completed"].includes(
          status
        )
      ) {
        return "Job Completed";
      } else {
        return "Lead";
      }
    } else if (stage === "Lead" || stage === "Opportunity") {
      return stage;
    } else if (status === "Job Canceled") {
      return "Canceled";
    } else {
      return "Lead";
    }
  }

  const getBackgroundColor = () => {
    switch (item?.ReferralStage) {
      case "Opportunity":
        return "rgba(255, 240, 178, 1)"; // Light Yellow
      case "Proposal":
        return "rgba(255, 208, 188, 1)"; // Light Orange
      case "Closure":
      case "Lead":
        return "rgba(183, 241, 126, 1)"; // Light Green
      default:
        return "rgb(140, 255, 0)"; // Default Green
    }
  };

  return (
    <div className={className}>
      <Box className="cardContainer">
        {/* Referral Details */}
        <Box className="detailsContainer">
          <Typography className="name">{item?.ReferralName}</Typography>
          <Typography className="email">{item?.ReferralEmail}</Typography>
          <Typography className="phone">{item?.ReferralPhone}</Typography>
        </Box>

        {/* Status Badge */}
        <Box
          className="badgeContainer"
          sx={{
            backgroundColor: getBackgroundColor(),
          }}
        >
          <Typography className="badgeText">
            {getDisplayStatus(item?.ReferralStage, item?.ReferralStatus)}
          </Typography>
        </Box>
      </Box>
    </div>
  );
}

export default styled(TrackCard)(() => ({
  ".container": {
    display: "flex",
  },
  ".cardContainer": {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "rgba(127, 168, 135, 0.1)",
    borderRadius: "12px",
    padding: "15px",
    margin: "12px 0",
    width: "80%",
    maxWidth: "500px",
    minWidth: "300px",
    border: "1px solid rgba(127, 168, 135, 0.3)",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
  },
  ".detailsContainer": {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  ".name": {
    fontSize: "18px",
    fontWeight: "bold",
    color: "rgba(35, 64, 0, 1)",
  },
  ".email": {
    fontSize: "14px",
    color: "rgba(35, 64, 0, 1)",
  },
  ".phone": {
    fontSize: "13px",
    color: "rgba(35, 64, 0, 1)",
  },
  ".badgeContainer": {
    position: "absolute",
    top: "10px",
    right: "10px",
    borderRadius: "20px",
    padding: "4px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ".badgeText": {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#000",
  },
}));
